import React, { Suspense } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { LayoutSplashScreen } from "../layout";
import Admin from "../view/dashboard/admin";
import AddAdmin from "../view/dashboard/admin/addAdmin";
import Car from "../view/dashboard/car";
import AddCar from "../view/dashboard/car/addCar";
import LateReport from "../view/dashboard/lateReport";
import Location from "../view/dashboard/location";
import AddLocation from "../view/dashboard/location/addlocation";
import News from "../view/dashboard/news";
import AddNews from "../view/dashboard/news/addnews";
import DriverNews from "../view/dashboard/driverNews";
import AddDriverNews from "../view/dashboard/driverNews/addnews";
import AddNotification from "../view/dashboard/notification";
import ReachedValue from "../view/dashboard/reachedValue";
import Path from "../view/dashboard/path";
import AddPath from "../view/dashboard/path/addPath";
import PathGroup from "../view/dashboard/pathGroup";
import AddPathGroup from "../view/dashboard/pathGroup/addPathGroup";
import privacyPolicy from "../view/dashboard/privacyPolicy";
import OtherInfo from "../view/dashboard/otherInfoDriver";
import DriverFcmConfig from "../view/dashboard/driverFcmConfig";
import CancelSchedule from "../view/dashboard/cancelSchedule";
import SiteDB from "../view/dashboard/siteDB";
import AddSite from "../view/dashboard/siteDB/addsite";
import Template from "../view/dashboard/template";
import AddTemplate from "../view/dashboard/template/addTemlate";
import SetSchedule from "../view/dashboard/template/setSchedule";
import SetPreSchedule from "../view/dashboard/preSchedule/setSchedule";
import TermsandCondition from "../view/dashboard/termsCondition";
import UserManual from "../view/dashboard/userManual";
import NotesToPassenger from "../view/dashboard/notesToPassenger";
import NotesToPassengerWeb from "../view/dashboard/notesToPassengerWeb";
import DownloadApp from "../view/dashboard/DownloadApp";
import User from "../view/dashboard/user";
import AddUser from "../view/dashboard/user/adduser";
import MO from "../view/dashboard/mo";
import AddMO from "../view/dashboard/mo/addMo";
import Staff from "../view/dashboard/staff";
import AddStaff from "../view/dashboard/staff/addStaff";
import StaffPermission from "../view/dashboard/staffPermission";
import ScheduleDaily from "../view/dashboard/scheduleDaily";
import ScheduleDailyTemplate from "../view/dashboard/scheduleDaily/ScheduleDailyTemplate";
import LogoImage from "../view/dashboard/logoImage";
import Reason from "../view/dashboard/reason";
import AddReason from "../view/dashboard/reason/addReason";
import AddLateReport from "../view/dashboard/lateReport/addLateReport";
import AppInfo from "../view/dashboard/appinfo";
import ScheduleReport from "../view/dashboard/scheduleReport";
import AddScheduleReport from "../view/dashboard/scheduleReport/addScheduleReport";
import AddScheduleManage from "../view/dashboard/scheduleReport/addScheduleManage";
import CompanyInfo from "../view/dashboard/companyInfo/index";
import InquiryService from "../view/dashboard/inquiryService";
import InquiryDetails from "../view/dashboard/inquiryService/details";
import ContactUs from "../view/dashboard/contactUs";
import ServiceTag from "../view/dashboard/serviceTag";
import AddServiceTag from "../view/dashboard/serviceTag/addServiceTag";
import ServiceTagDetails from "../view/dashboard/serviceTag/addServiceTag";
import CompanyService from "../view/dashboard/companyService";
import AddCompanyService from "../view/dashboard/companyService/addCompanyService";
import PreSchedule from "../view/dashboard/preSchedule";
import PreScheduleAdd from "../view/dashboard/preSchedule/addPreschedule";

import ExportDailyReport from "../view/Report/DailyReport";
import ExportMonthlyReport from "../view/Report/MonthlyReport";
import ExportMonthltManuLifeReport from "../view/Report/MonthyReportManuLife/index";
import Welcome from "../view/dashboard/welcome";
import { PrivateRoute } from "./PrivateRoute";

export default function BasePage() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        {<Redirect exact from="/" to="/welcome" />}

        {/* <Route exact path="/auth/login" component={Login} /> */}
        <Route exact path="/welcome" component={Welcome} />
        <PrivateRoute exact path="/site" component={SiteDB} />
        <PrivateRoute exact path="/site/update/:id" component={AddSite} />
        <PrivateRoute exact path="/site/add" component={AddSite} />
        <PrivateRoute exact path="/s-car" component={Car} />
        <PrivateRoute exact path="/s-car/add" component={AddCar} />
        <PrivateRoute exact path="/s-car/update/:id" component={AddCar} />
        <PrivateRoute exact path="/car" component={Car} />
        <PrivateRoute exact path="/car/add" component={AddCar} />
        <PrivateRoute exact path="/car/update/:id" component={AddCar} />
        <PrivateRoute exact path="/s-location" component={Location} />
        <PrivateRoute exact path="/s-location/update/:id" component={AddLocation} />
        <PrivateRoute exact path="/s-location/add" component={AddLocation} />
        <PrivateRoute exact path="/location" component={Location} />
        <PrivateRoute exact path="/location/update/:id" component={AddLocation} />
        <PrivateRoute exact path="/location/add" component={AddLocation} />
        <PrivateRoute exact path="/path" component={Path} />
        <PrivateRoute exact path="/path/update/:id" component={AddPath} />
        <PrivateRoute exact path="/path/add" component={AddPath} />
        <PrivateRoute exact path="/PathGroup" component={PathGroup} />
        <PrivateRoute exact path="/PathGroup/update/:id" component={AddPathGroup} />
        <PrivateRoute exact path="/PathGroup/add" component={AddPathGroup} />
        <PrivateRoute exact path="/template" component={Template} />
        <PrivateRoute exact path="/template/update/:id" component={AddTemplate} />
        <PrivateRoute
          exact
          path="/template/update/:id/set/schedule"
          component={SetSchedule}
        />
        <PrivateRoute
          exact
          path="/pre-schedule/update/:id/set/schedule"
          component={SetPreSchedule}
        />
        <PrivateRoute exact path="/template/add" component={AddTemplate} />
        <PrivateRoute
          exact
          path="/template/add/:id/set/schedule"
          component={SetSchedule}
        />
        <PrivateRoute
          exact
          path="/pre-schedule/add/:id/set/schedule"
          component={SetPreSchedule}
        />
        <PrivateRoute exact path="/schedule/daily" component={ScheduleDaily} />
        <PrivateRoute
          exact
          path="/schedule/daily/:siteId/s_template"
          component={ScheduleDailyTemplate}
        />
        <PrivateRoute exact path="/pre-schedule" component={PreSchedule} />
        <PrivateRoute exact path="/pre-schedule/add" component={PreScheduleAdd} />
        <PrivateRoute
          exact
          path="/pre-schedule/update/:id"
          component={PreScheduleAdd}
        />
        <PrivateRoute exact path="/user" component={User} />
        <PrivateRoute exact path="/user/update/:id" component={AddUser} />
        <PrivateRoute exact path="/user/add" component={AddUser} />
        <PrivateRoute exact path="/mo" component={MO} />
        <PrivateRoute exact path="/mo/update/:id" component={AddMO} />
        <PrivateRoute exact path="/mo/add" component={AddMO} />
        <PrivateRoute exact path="/staff" component={Staff} />
        <PrivateRoute exact path="/staff/update/:id" component={AddStaff} />
        <PrivateRoute exact path="/staff/add" component={AddStaff} />
        <PrivateRoute exact path="/staff/permission" component={StaffPermission} />
        <PrivateRoute exact path="/admin" component={Admin} />
        <PrivateRoute exact path="/admin/update/:id" component={AddAdmin} />
        <PrivateRoute exact path="/admin/add" component={AddAdmin} />
        <PrivateRoute exact path="/notification" component={AddNotification} />
        <PrivateRoute exact path="/reachedValue" component={ReachedValue} />
        <PrivateRoute exact path="/s-news" component={News} />
        <PrivateRoute exact path="/s-news/update/:id" component={AddNews} />
        <PrivateRoute exact path="/s-news/add" component={AddNews} />
        <PrivateRoute exact path="/news" component={News} />
        <PrivateRoute exact path="/news/update/:id" component={AddNews} />
        <PrivateRoute exact path="/news/add" component={AddNews} />
        <PrivateRoute exact path="/drivernews" component={DriverNews} />
        <PrivateRoute exact path="/drivernews/update/:id" component={AddDriverNews} />
        <PrivateRoute exact path="/drivernews/add" component={AddDriverNews} />
        <PrivateRoute exact path="/lateReport" component={LateReport} />
        <PrivateRoute exact path="/lateReport/add" component={AddLateReport} />
        <PrivateRoute exact path="/lateReport/edit/:id" component={AddLateReport} />
        <PrivateRoute exact path="/privacyPolicy" component={privacyPolicy} />
        <PrivateRoute exact path="/companyInfo" component={CompanyInfo} />
        <PrivateRoute exact path="/otherInfo" component={OtherInfo} />
        <PrivateRoute exact path="/driverFcmConfig" component={DriverFcmConfig} />
        <PrivateRoute exact path="/termsCondition" component={TermsandCondition} />
        <PrivateRoute exact path="/cancel-schedule" component={CancelSchedule} />
        <PrivateRoute exact path="/logoImage" component={LogoImage} />
        <PrivateRoute exact path="/s-userManual" component={UserManual} />
        <PrivateRoute exact path="/appinfo" component={AppInfo} />
        <PrivateRoute exact path="/s-app-info" component={AppInfo} />
        <PrivateRoute exact path="/notesToPassenger" component={NotesToPassenger} />
        <PrivateRoute
          exact
          path="/notes-to-passenger-web"
          component={NotesToPassengerWeb}
        />
        <PrivateRoute exact path="/download-app" component={DownloadApp} />
        <PrivateRoute exact path="/reason" component={Reason} />
        <PrivateRoute exact path="/reason/add" component={AddReason} />
        <PrivateRoute exact path="/reason/update/:id" component={AddReason} />
        <PrivateRoute exact path="/ScheduleReport" component={ScheduleReport} />
        <PrivateRoute exact path="/ScheduleReport/Add" component={AddScheduleReport} />
        <PrivateRoute
          exact
          path="/ScheduleReport/update/:id"
          component={AddScheduleReport}
        />
        <PrivateRoute
          exact
          path="/ScheduleReport/details/:schedule_id/:location_id"
          component={AddScheduleManage}
        />
        <PrivateRoute exact path="/companyService/list" component={CompanyService} />
        <PrivateRoute exact path="/companyService/add" component={AddCompanyService} />
        <PrivateRoute
          exact
          path="/companyService/details/:id"
          component={AddCompanyService}
        />
        <PrivateRoute
          exact
          path="/companyService/inquiryService"
          component={InquiryService}
        />
        <PrivateRoute
          exact
          path="/companyService/inquiryService/:id"
          component={InquiryDetails}
        />
        <PrivateRoute exact path="/contact-us" component={ContactUs} />
        <PrivateRoute exact path="/companyService/serviceTag" component={ServiceTag} />
        <PrivateRoute
          exact
          path="/companyService/serviceTag/add"
          component={AddServiceTag}
        />
        <PrivateRoute
          exact
          path="/companyService/serviceTag/:id"
          component={ServiceTagDetails}
        />
        <PrivateRoute
          exact
          path="/export/daily-report"
          component={ExportDailyReport}
        />

        <PrivateRoute
          exact
          path="/export/monthly-report"
          component={ExportMonthlyReport}
        />
        <PrivateRoute
          exact
          path="/export/monthly-manulife-report"
          component={ExportMonthltManuLifeReport}
        />
      </Switch>
    </Suspense>
  );
}
